module.exports = __webpack_public_path__ + "img/HM.da854e0a.png";